import type {
  ProjectGraphFinding,
  ProjectGraphRuleFinding,
  ProjectGraphRuleStatus,
  SupervisorFindingStatus,
  SupervisorSeverity,
} from '@avisoma/shared';

/** The graph's supervisor findings about one node, in the graph's order. */
export function findingsForNode(findings: ProjectGraphFinding[] | undefined, nodeId: string): ProjectGraphFinding[] {
  return (findings ?? []).filter((finding) => finding.nodeIds.includes(nodeId));
}

/** The graph's rule findings about one node, in the graph's order. */
export function ruleFindingsForNode(
  ruleFindings: ProjectGraphRuleFinding[] | undefined,
  nodeId: string,
): ProjectGraphRuleFinding[] {
  return (ruleFindings ?? []).filter((finding) => finding.nodeId === nodeId);
}

/** Statuses whose finding still stands; any other (dismissed, rejected, obsolete, …) is muted. */
const ACTIVE_STATUSES: ReadonlySet<SupervisorFindingStatus> = new Set(['proposed', 'applied', 'reapplied']);

/** The badge colour of a finding: an active one by severity (error red, warning amber, info zinc), any other zinc. */
export function severityColor(severity: SupervisorSeverity, status: SupervisorFindingStatus): 'red' | 'amber' | 'zinc' {
  if (!ACTIVE_STATUSES.has(status)) return 'zinc';
  return severity === 'error' ? 'red' : severity === 'warning' ? 'amber' : 'zinc';
}

/** The badge colour of a rule finding: critical red, warning amber, unknown (input missing) zinc. */
export function ruleStatusColor(status: ProjectGraphRuleStatus): 'red' | 'amber' | 'zinc' {
  return status === 'critical' ? 'red' : status === 'warning' ? 'amber' : 'zinc';
}
